<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectStockTypes" });
import TagList from "../../../../selects/tag-list/TagList.svelte";
import { STOCK_TYPES } from "../../config/stock-types.js";
export let keys;
export let name = "stock-types";
export let label = "Order Type";
export let isDisabled = false;
export let minItems = 0;
export let maxItems = 1e3;
</script>

{#if Array.isArray(keys) }
    <TagList
        bind:keys
        { name }
        options = { STOCK_TYPES }
        { label }
        { minItems }
        { maxItems }
        { isDisabled }
        mode = 'toggle'
    />
{/if}